import { render, staticRenderFns } from "./LandingWishlistIT-V2.vue?vue&type=template&id=214b71f4&scoped=true"
import script from "./LandingWishlistIT-V2.vue?vue&type=script&lang=js"
export * from "./LandingWishlistIT-V2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "214b71f4",
  null
  
)

export default component.exports